import { ListItem, ListItemProps, styled } from '@mui/material';

const NavItem = styled(ListItem, { shouldForwardProp: (prop) => prop !== 'active' })<
    ListItemProps & { active?: boolean }
>(
    ({ theme, active }) => `
    display: flex;
    justify-content: center;
    width: auto;
    padding: ${theme.spacing(2, 0)};
    margin-bottom: ${theme.spacing(1)};
    justify-content: center;
    color: ${active ? theme.palette.common.white : theme.nav.text};
    &:hover: {
        color: ${theme.palette.common.white};
    }
    background-color: ${active ? theme.nav.active : 'transparent'};
    border-left: solid ${theme.spacing(1)} transparent;
    border-left-color: ${active ? theme.palette.primary.light : 'transparent'};
    cursor: pointer;
    .MuiButtonBase-root {
        margin-right: ${theme.spacing(1)};
    }
`,
);

NavItem.displayName = 'NavItem';
export default NavItem;
